import { Separator, Skeleton } from '@radix-ui/themes';

import { EnvironmentCardSkeleton } from './EnvironmentsGrid/EnvironmentCardSkeleton';

export const EnvironmentsSkeleton = () => {
  return (
    <div
      className='flex flex-col'
      data-testid='runtime-environments-page-skeleton'
    >
      <Separator
        orientation='horizontal'
        size='4'
        className='-ml-6 mb-[22px] w-[calc(100%+48px)]'
      />
      <Skeleton className='my-fly-4 h-[30px] w-full rounded-fly-4' />
      <div className='sm:grid-cols-[repeat(auto-fit,_minmax(312px,_1fr))] px-3 mt-fly-5 grid gap-fly-5'>
        <EnvironmentCardSkeleton />
        <EnvironmentCardSkeleton />
        <EnvironmentCardSkeleton />
        <EnvironmentCardSkeleton />
      </div>
    </div>
  );
};

export default EnvironmentsSkeleton;
